import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../../app/hooks";
import ObjectInsUpd from "../../../../features/base/page/ObjectInsUpd";
import { isValidTime, ScheduleInfo, timeToMinutes } from "../../../../redux/curriculum/model";
import { scheduleInsUpdSlice, scheduleInsert, selectScheduleInsUpd, scheduleUpdate } from "../../../../redux/curriculum/scheduleInsUpdSlice";
import { scheduleListSlice } from "../../../../redux/curriculum/scheduleListSlice";
import { ScheduleInsUpdData } from "./ScheduleInsUpdData";
import { ScheduleInsUpdReview } from "./ScheduleInsUpdReview";

export interface ScheduleInsUpdProps {
    back: () => void;
    schoolId: string;
    classroomId: string;
    schedule?: ScheduleInfo;
}

export function ScheduleInsUpd({ back, schoolId, classroomId, schedule }: ScheduleInsUpdProps) {
    const dispatch = useAppDispatch();
    const scheduleInsUpd = useSelector(selectScheduleInsUpd);

    const editing = schedule !== undefined;

    if (editing) {
        if (scheduleInsUpd.schedule.schoolId <= 0 && schedule) {
            const changing = {
                ...schedule
            };
            dispatch(scheduleInsUpdSlice.actions.set(changing));
        }
    } else {
        if (scheduleInsUpd.schedule.schoolId <= 0) {
            const changing = {
                ...scheduleInsUpd.schedule,
                schoolId: Number(schoolId),
                classroomId: Number(classroomId),
            };
            dispatch(scheduleInsUpdSlice.actions.set(changing));
        }
    }

    const steps = [
        {
            name: "Dados do Horário",
            component: <ScheduleInsUpdData />,
            check: () =>
                scheduleInsUpd.schedule.subjectId > 0
                && isValidTime(scheduleInsUpd.schedule.startTime)
                && isValidTime(scheduleInsUpd.schedule.endTime)
                && timeToMinutes(scheduleInsUpd.schedule.startTime) < timeToMinutes(scheduleInsUpd.schedule.endTime),
        },
        {
            name: "Revisão",
            component: <ScheduleInsUpdReview />,
        }
    ];

    return <ObjectInsUpd
        name="horário"
        submit={() =>
            (editing)
                ? dispatch(scheduleUpdate({ scheduleId: schedule!.id, schedule: scheduleInsUpd.schedule }))
                : dispatch(scheduleInsert({ schedule: scheduleInsUpd.schedule }))
        }
        backTo={back}
        backCleanup={() => {
            dispatch(scheduleListSlice.actions.clean());
            dispatch(scheduleInsUpdSlice.actions.clean());
        }}
        state={scheduleInsUpd.state}
        steps={steps}
        edit={editing}
    />;
}
